import React from 'react';
import { Select, Spin } from 'antd';

const { Option } = Select;

export const svrdCols = [
    {
        title: '序号',
        en_title: 'S/N',
        ch_title: '序号',
        dataIndex: '序号',
    },
    {
        title: '生成日期',
        en_title: 'Date Generated',
        ch_title: '生成日期',
        dataIndex: '生成日期',
        sorter: (a, b) => a['生成日期'].localeCompare(b['生成日期']),
        renderFormItem: () => {
            return <Spin tip='加载中'></Spin>
        }
    },
    {
        title: '开立票据份数',
        en_title: 'Number of Ticket Issued',
        ch_title: '开立票据份数',
        dataIndex: '开立票据份数',
    },
    {
        title: '票据总额',
        en_title: 'Ticket Total Amount',
        ch_title: '票据总额',
        dataIndex: '票据总额',
    },
    {
        title: '地区',
        en_title: 'Region',
        ch_title: '地区',
        dataIndex: '地区',
        renderFormItem: () => {
            return <Spin tip='加载中'></Spin>
        }
    },
    {
        title: '操作人员',
        en_title: 'Operators',
        ch_title: '操作人员',
        dataIndex: '操作人员',
        renderFormItem: () => {
            return <Spin tip='加载中'></Spin>;
        }
    },
    {
        title: '志工人数',
        en_title: 'Number of Volunteers',
        ch_title: '志工人数',
        dataIndex: '志工人数',
    },
    // {
    //     title: '导入状态',
    //     en_title: 'Import Status',
    //     ch_title: '导入状态',
    //     dataIndex: '导入状态',
    //     filters: [
    //         {
    //             text: '已导入',
    //             value: '已导入',
    //         },
    //         {
    //             text: '未导入',
    //             value: '未导入',
    //         },
    //     ],
    //     filterMode: 'tree',
    //     onFilter: (value, record) => record['导入状态'] == value,
    //     sorter: (a, b) => a['导入状态'].localeCompare(b['导入状态']),
    //     // renderFormItem: () => {
    //     //     return <Select defaultValue="" >
    //     //         <Option key="all" value="">所有状态</Option>
    //     //         <Option key="unuploaded" value="未导入">未导入</Option>
    //     //         <Option key="uploaded" value="已导入">已导入</Option>
    //     //     </Select>
    //     // }
    // },
];

